"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalFormDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const store_1 = require("../store");
const types_1 = require("../types");
const schemas_1 = require("../schemas");
const GlobalFormDialog = (props) => {
    const { externalDialogComponentSchema = {} } = props;
    const options = (0, store_1.useGlobalFormDialogStore)(state => state.options);
    const key = (0, store_1.useGlobalFormDialogStore)(state => state.key);
    const selectedItem = (0, store_1.useGlobalFormDialogStore)(state => state.selectedItem);
    const closeDialog = (0, store_1.useGlobalFormDialogStore)(state => state.closeDialog);
    const open = key !== types_1.GlobalDialogKeys.DEFAULT;
    if (!open || !options) {
        return null;
    }
    const { componentProps = {}, componentNeedsOpen = false, prepareInitialValues, ...restDialogFormProps } = options || {};
    const initialValues = prepareInitialValues && selectedItem ? prepareInitialValues(selectedItem) : options.initialValues;
    return ((0, jsx_runtime_1.jsx)(mui_dialog_form_1.FormDialog, { ...restDialogFormProps, initialValues: initialValues, open: open, onCloseModal: closeDialog, children: (0, schemas_1.renderComponent)(externalDialogComponentSchema, key, {
            ...componentProps,
            selectedItem,
            open: componentNeedsOpen ?? open,
        }) }));
};
exports.GlobalFormDialog = GlobalFormDialog;
//# sourceMappingURL=global-form.js.map